module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_h('mu-appbar', {
    attrs: {
      "title": "產品列表"
    }
  }), " ", _h('mu-content-block', [_h('div', {
    staticClass: "demo-grid"
  }, [_h('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_h('mu-col', {
    attrs: {
      "width": "0",
      "tablet": "0",
      "desktop": "20"
    }
  }), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "30"
    }
  }, [_h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "label": "物品名稱",
      "type": "text",
      "errorText": "不可空白",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        _vm.title = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.price),
      expression: "price"
    }],
    attrs: {
      "label": "價格",
      "type": "number",
      "errorText": "不可空白",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "input": function($event) {
        _vm.price = _vm._n($event)
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "label": "地點",
      "type": "text",
      "hintText": "如：台北市大安區",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        _vm.address = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "hintText": "(選擇性填寫)敘述你要賣的物品吧，如：尺寸，顏色",
      "multiLine": "",
      "rows": 4
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        _vm.description = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "label": "關鍵字",
      "type": "text",
      "hintText": "逗點分隔關鍵字，如：nike,puma...",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        _vm.keywords = $event
      }
    }
  }), _h('br')]), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "30"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": _vm.title,
      "subTitle": ' NT$' + _vm.price
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              地點：" + _vm._s(_vm.address) + "\n              ", _h('pre', [_vm._s(_vm.description)])]), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, [_vm._l((_vm.splitArray), function(keyword) {
    return _h('div', [_h('span', [_h('a', {
      attrs: {
        "href": '#' + keyword
      }
    }, ["#" + _vm._s(keyword)])])])
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "丟訊息問問 Wu Yi-Ju"
    }
  })])])]), " ", _h('mu-col', {
    attrs: {
      "width": "0",
      "tablet": "0",
      "desktop": "20"
    }
  })])])]), " ", _h('mu-content-block', [_h('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('h1', ["所有物品"])])]), " ", _h('div', {
    staticClass: "demo-grid"
  }, [_h('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": "櫃子 $ 500",
      "subTitle": "地點：台北縣新莊區"
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#aa"])]), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#bb"])])]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "詢問"
    }
  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })])])]), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": "櫃子 $ 500",
      "subTitle": "地點：台北縣新莊區"
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              The overflow-wrap property is used to specify whether or not the browser may break lines within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.The overflow-wrap property is used to specify whether or not the browser may break lines within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.The overflow-wrap property is used to specify whether or not the browser may break linesasdhfaioshdfliuahsdlifuhIGWRUHIRAUHGAILERUHGLIRAUEHGLIERUHFASDFHASODFHOADS within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.", _h('br'), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#aa"])]), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#bb"])])]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "詢問"
    }
  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })])])]), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": "櫃子 $ 500",
      "subTitle": "地點：台北縣新莊區"
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#aa"])]), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#bb"])])]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "詢問"
    }
  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })])])]), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": "櫃子 $ 500",
      "subTitle": "地點：台北縣新莊區"
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#aa"])]), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#bb"])])]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "詢問"
    }
  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })])])]), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": "櫃子 $ 500",
      "subTitle": "地點：台北縣新莊區"
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#aa"])]), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#bb"])])]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "詢問"
    }
  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })])])]), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    attrs: {
      "src": _vm.img
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": "櫃子 $ 500",
      "subTitle": "地點：台北縣新莊區"
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#aa"])]), " ", _h('span', [_h('a', {
    attrs: {
      "href": "#"
    }
  }, ["#bb"])])]), " ", _h('mu-card-header', {
    attrs: {
      "title": "5小時前 建立",
      "subTitle": "來自 Wu Yi-Ju"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
    attrs: {
      "label": "詢問"
    }
  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })]), " ", _h('mu-card-header', {
    attrs: {
      "title": "Myron Avatar",
      "subTitle": "哈囉你好"
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.myron
    },
    slot: "avatar"
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d376152!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Example.vue
// module id = 92
// module chunks = 2